import React, { ReactNode } from 'react';
import Navigation from '../../../components/layout/Navigation';
import { DashboardProvider } from '../../../features/portfolio/context/PortfolioViewContext';
import Footer from './Footer';
import { useAuth } from '../../../features/auth/context/AuthContext';
import ReactivationModal from '../../../features/auth/components/ReactivationModal';

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { needsReactivation, reactivateAccount, logout } = useAuth();

  const handleReactivate = async () => {
    try {
      await reactivateAccount();
    } catch (error) {
      console.error('Failed to reactivate portfolio:', error);
      // Error is already logged, modal will stay open
    }
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <DashboardProvider>
      <div className="min-h-screen flex flex-col bg-gray-100">
        <Navigation />
        <main className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
          {children}
        </main>
        <Footer />
      </div>
      
      {/* Reactivation Modal */}
      <ReactivationModal
        isOpen={needsReactivation}
        onReactivate={handleReactivate}
        onLogout={handleLogout}
      />
    </DashboardProvider>
  );
};

export default AuthLayout; 
